import { EoFormControlBlock } from "./eo-form-control-block.model";

export class EoFormPanelBlock {
    header: string;
    name: string
    formControls: EoFormControlBlock[];
  
    constructor(header: string, name: string,  formControls: EoFormControlBlock[]) {
      this.header = header;
      this.name = name;
      this.formControls = formControls;
    }
  }
  